// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MODEL PAGE STYLES
   ============================================ */

/* Model Page Layout */
.model_page {
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);
  padding: var(--space-xl);
  min-height: 100vh;
}

.model_content {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: var(--space-xl);
  align-items: start;
  width: 100%;
  max-width: 1800px;
  margin: 0 auto;
}

.center_column {
  display: flex;
  flex-direction: column;
  gap: var(--space-xl);
}

.right_column {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ============================================
   MODEL HEADER STYLES
   ============================================ */

.model-header {
  padding: 0;
  background: transparent;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: var(--radius-3xl);
  border: 1px solid var(--border-glass);
  border-left: 4px solid var(--color-accent-cyan);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.model-header__container {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: var(--space-xl);
  align-items: center;
  padding: 1.25rem var(--space-xl);
}

.model-header__icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(10, 230, 211, 0.05);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-cyan);
}

.model-header__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

.model-header__content {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.model-header__title {
  font-size: var(--font-size-3xl);
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
  line-height: 1.3;
}

.model-header__description {
  font-size: var(--font-size-md);
  color: var(--color-text-muted);
  line-height: 1.5;
  margin: 0;
}

.model-header__price-section {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.35rem;
}

.model-header__price {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--color-text-primary);
  line-height: 1;
}

.model-header__date {
  font-size: var(--font-size-base);
  color: var(--color-text-dim);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.model-header__period {
  color: rgba(255, 255, 255, 0.5);
  font-size: var(--font-size-sm);
  font-weight: 400;
}

.model-header__null {
  color: rgba(255, 165, 0, 0.7);
  font-style: italic;
  font-size: 0.8em;
}

.model-header__change-row {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  font-size: var(--font-size-md);
}

.model-header__change-pct {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.model-header__change-icon {
  margin-right: 4px;
}

.model-header__change-pct.positive {
  color: var(--color-positive);
}

.model-header__change-pct.negative {
  color: var(--color-negative);
}

.model-header__change-value {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 400;
}

.model-header__change-period {
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.75rem;
  font-weight: 400;
  margin-left: 4px;
}

.model-header__edit-btn {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-md) 1.25rem;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(99, 102, 241, 0.2));
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  color: var(--color-primary-muted);
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
  margin-left: var(--space-lg);
}

.model-header__edit-btn:hover {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.35), rgba(99, 102, 241, 0.35));
  border-color: var(--border-primary-hover);
  color: var(--color-text-primary);
  transform: translateY(-1px);
}


/* ============================================
   SUB-PRODUCT TOGGLE PANEL STYLES
   ============================================ */

.subproduct-toggle-panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  padding: var(--space-md) var(--space-lg);
  background: transparent;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: var(--radius-3xl);
  border: 1px solid var(--border-glass);
  margin-bottom: var(--space-lg);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.toggle-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.toggle-panel-title {
  font-size: var(--font-size-sm);
  font-weight: 500;
  color: var(--color-text-dim);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.toggle-panel-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-sm);
}

.toggle-panel-item {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: 0.4rem var(--space-md);
  background: var(--surface-subtle-hover);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: var(--transition-fast);
}

.toggle-panel-item.active {
  background: var(--border-primary-subtle);
  border-color: var(--border-primary-light);
}

.toggle-panel-item.inactive {
  opacity: 0.5;
}

.toggle-panel-item:hover {
  border-color: rgba(139, 92, 246, 0.5);
}

.toggle-color-indicator {
  width: 10px;
  height: 10px;
  border-radius: var(--radius-circle);
}

.toggle-item-name {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toggle-icon {
  color: var(--color-text-dim);
}

/* ============================================
   MODEL BREAKDOWN TABLE STYLES
   ============================================ */

.model-breakdown {
  padding: 0rem;
  margin:0.5rem 0rem;
}

.model-breakdown__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--space-xl);
}

.model-breakdown__title {
  font-size: var(--font-size-2xl);
  font-weight: 600;
  color: var(--color-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.model-breakdown__table {
  width: 100%;
  border-collapse: collapse;
  background: transparent;
}

.model-breakdown__table thead tr {
  background: transparent;
  border-bottom: none;
}

.model-breakdown__table th {
  padding: 0.65rem 0.85rem;
  text-align: left;
  font-size: var(--font-size-md);
  font-weight: 500;
  color: var(--color-text-dim);
  font-style: italic;
  letter-spacing: 0.3px;
}

.model-breakdown__table tbody tr {
  border-bottom: none;
  transition: background-color 0.2s ease;
}

.model-breakdown__table tbody tr:hover {
  background-color: var(--surface-subtle);
}

.model-breakdown__table tbody tr:last-child {
  border-bottom: none;
}

.model-breakdown__table td {
  padding: var(--space-md) 0.85rem;
  font-size: var(--font-size-md);
  color: rgba(255, 255, 255, 0.9);
}

.model-breakdown__component-name {
  font-weight: 400;
  color: var(--color-text-primary);
  font-size: var(--font-size-md);
  line-height: 1.3;
}

.model-breakdown__component-code {
  color: var(--color-text-dim);
  font-size: var(--font-size-sm);
  font-family: 'Courier New', monospace;
}

.model-breakdown__section {
  margin-bottom: var(--space-lg);
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  box-shadow: none;
}


.model-breakdown__section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 1rem;
  background: transparent; border-bottom: none;
  border-radius: 0.5rem 0.5rem 0 0;
  border-bottom: none;
}

.model-breakdown__section-title {
  font-size: var(--font-size-lg);
  font-weight: 500;
  color: var(--color-text-secondary);
}

.model-breakdown__section-actions {
  display: flex;
  align-items: center;
  gap: var(--space-xl);
}

.model-breakdown__show-chart-btn {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: 0.4rem 0.8rem;
  background: transparent;
  border: 1px solid var(--border-medium);
  border-radius: var(--radius-pill);
  color: var(--color-text-light-gray);
  font-weight: 400;
  font-size: var(--font-size-sm);
  cursor: pointer;
  transition: var(--transition-fast);
}

.model-breakdown__show-chart-btn:hover {
  background: rgba(99, 102, 241, 0.1);
  border-color: rgba(99, 102, 241, 0.6);
}

.model-breakdown__show-chart-btn svg {
  width: 10px;
  height: 10px;
}

.model-breakdown__show-chart-btn.active {
  background: rgba(16, 185, 129, 0.15);
  border-color: rgba(16, 185, 129, 0.5);
  color: #10B981;
}

.model-breakdown__show-chart-btn.active svg circle {
  stroke: #10B981;
  fill: rgba(16, 185, 129, 0.2);
}

.model-breakdown__section-header--collapsible {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.model-breakdown__section-header--collapsible:hover {
  background: rgba(255, 255, 255, 0.03);
}

.model-breakdown__section-title-group {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  color: var(--color-text-secondary);
}

.model-breakdown__component-name--link {
  color: var(--color-text-secondary);
  text-decoration: none;
  transition: color 0.15s ease;
}

.model-breakdown__component-name--link:hover {
  color: var(--color-primary-muted);
  text-decoration: underline;
}

.model-breakdown__section-price {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--color-text-primary);
}

.model-breakdown__section-currency {
  font-weight: 400;
  color: #9CA3AF;
  margin-left: 6px;
}

.model-breakdown__stability {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.model-breakdown__stability-segment {
  width: 18px;
  height: 3px;
  border-radius: 2px;
}

.model-breakdown__stability-bar {
  width: 60px;
  height: 4px;
  background: var(--border-default);
  border-radius: 2px;
  overflow: hidden;
}

.model-breakdown__stability-fill {
  height: 100%;
  border-radius: 2px;
  transition: width 0.3s ease;
}

.model-breakdown__stability-fill--high {
  background: linear-gradient(90deg, var(--color-positive), var(--color-positive-vivid));
}

.model-breakdown__stability-fill--medium {
  background: linear-gradient(90deg, var(--color-warning), var(--color-warning-vivid));
}

.model-breakdown__stability-fill--low {
  background: linear-gradient(90deg, var(--color-negative), var(--color-negative-vivid));
}

.model-breakdown__mini-chart {
  width: 70px;
  height: 28px;
}

.model-breakdown__price {
  font-weight: 400;
  color: var(--color-text-primary);
  font-size: var(--font-size-md);
  line-height: 1.4;
}

.model-breakdown__change {
  font-size: 13px;
  font-weight: 400;
  margin-top: 2px;
}

.model-breakdown__change--positive {
  color: var(--color-positive);
}

.model-breakdown__change--negative {
  color: var(--color-negative);
}

.model-breakdown__price--market {
  color: #D1D5DB;
}

.model-breakdown__mini-chart-empty {
  width: 100%;
  height: 100%;
}

.model-breakdown__source {
  font-size: var(--font-size-base);
  color: rgba(255, 255, 255, 0.6);
}

/* ============================================
   CLASSIFICATION PIE CHART STYLES
   ============================================ */

/* .classification-chart — root class not used in JSX;
   the component uses .news_comments as its outer glass container */
.classification-chart {
  padding: var(--space-xl);
}

.classification-chart__header {
  margin-bottom: var(--space-xl);
}

.classification-chart__title {
  font-size: var(--font-size-2xl);
  font-weight: 600;
  color: var(--color-text-primary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.classification-chart__content {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: var(--space-2xl);
  align-items: center;
  padding: var(--space-lg);
}

.classification-chart__chart-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}

.classification-chart__chart-container {
  width: 160px;
  height: 160px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.classification-chart__center-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: var(--font-size-2xl);
  font-weight: 500;
  color: var(--color-text-primary);
  text-align: center;
  pointer-events: none;
}

.classification-chart__legend {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  width: 100%;
  justify-content: center;
}

.classification-chart__legend--grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.25rem 0.5rem;
  align-content: center;
}

.classification-chart__legend-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-sm);
  background: transparent;
  transition: background-color 0.2s ease;
  gap: var(--space-md);
}

.classification-chart__legend-item:hover {
  background: var(--surface-subtle-hover);
}

.classification-chart__legend-label {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.classification-chart__legend-color {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.classification-chart__legend-name {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
}

.classification-chart__legend-value {
  font-size: var(--font-size-md);
  font-weight: 500;
  color: var(--color-text-primary);
  display: none;
}

/* ============================================
   PRICE BREAKDOWN PANEL STYLES
   ============================================ */

/* .price-breakdown sits on the same element as .news_comments,
   which already provides the glass container */
.price-breakdown {
  padding: 12px 10px;
}

.price-breakdown__header {
  margin-bottom: var(--space-md);
}

.price-breakdown__title {
  font-size: var(--font-size-xl);
  font-weight: 600;
  color: var(--color-text-primary);
  letter-spacing: 0.3px;
  text-align: center;
}

.price-breakdown__list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.price-breakdown__item {
  display: flex;
  align-items: baseline;
  padding: 0.5rem 0.5rem;
  background: transparent;
  border: none;
  transition: background-color 0.2s ease;
}

.price-breakdown__item.header {
  border-bottom: 1px solid var(--border-default);
  padding-bottom: var(--space-sm);
  margin-bottom: 0;
}

.price-breakdown__item.header .price-breakdown__item-name,
.price-breakdown__item.header .price-breakdown__item-percentage,
.price-breakdown__item.header .price-breakdown__item-price {
  font-size: var(--font-size-base);
  color: rgba(255, 255, 255, 0.45);
  font-style: italic;
  font-weight: 400;
}

.price-breakdown__item:not(.header):hover {
  background: var(--surface-subtle);
}

.price-breakdown__item-name {
  font-size: var(--font-size-md);
  color: var(--color-text-secondary);
  flex: 1 1;
  min-width: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.price-breakdown__item-percentage {
  font-size: var(--font-size-md);
  color: var(--color-text-dim);
  width: 40px;
  text-align: center;
  flex-shrink: 0;
}

.price-breakdown__item-price {
  font-size: var(--font-size-md);
  font-weight: 500;
  color: var(--color-text-primary);
  min-width: 110px;
  text-align: right;
  flex-shrink: 0;
}

.price-breakdown__total {
  margin-top: var(--space-sm);
  padding-top: var(--space-sm);
  border-top: 1px solid var(--border-default);
}

.price-breakdown__total-label {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--color-text-primary);
  flex: 1 1;
}

.price-breakdown__total-price {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--color-text-primary);
  min-width: 110px;
  text-align: right;
  flex-shrink: 0;
}

/* ============================================
   RESPONSIVE DESIGN
   ============================================ */

@media (max-width: 1200px) {
  .model_content {
    grid-template-columns: 1fr 350px;
  }
}

@media (max-width: 1024px) {
  .model_content {
    grid-template-columns: 1fr;
  }

  .right_column {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: var(--space-xl);
  }
}

@media (max-width: 768px) {
  .model_page {
    padding: var(--space-lg);
  }

  .model_content {
    gap: var(--space-lg);
  }

  .center_column,
  .right_column {
    gap: var(--space-lg);
  }

  .model-header {
    flex-direction: column;
    gap: var(--space-lg);
  }

  .model-header__price-info {
    align-items: flex-start;
  }

  .model-breakdown__table {
    font-size: 0.85rem;
  }

  .model-breakdown__table th,
  .model-breakdown__table td {
    padding: 0.5rem;
  }

  /* Make table horizontally scrollable on mobile */
  .model-breakdown {
    overflow-x: auto;
  }

  .model-breakdown__table {
    min-width: 800px;
  }
}

@media (max-width: 600px) {
  .model-header__title {
    font-size: 1.25rem;
  }

  .model-header__price {
    font-size: 1.5rem;
  }

  .right_column {
    grid-template-columns: 1fr;
  }
}
.model-breakdown__graph-cell {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

/* ── Tabs — glass pill bar within ModelPage ── */
.model_page .news-tabs {
  background: transparent;
  border: 1px solid var(--border-glass);
  border-radius: 50px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  padding: 4px;
}

.model_page .news-tab-btn {
  color: rgba(255, 255, 255, 0.45);
  border: 1px solid transparent;
  transition: color 0.25s, border-color 0.25s, background 0.25s;
}

.model_page .news-tab-btn.active {
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  box-shadow: none;
  color: #fff;
}

.model_page .news-tab-btn:hover:not(.active) {
  color: rgba(255, 255, 255, 0.7);
}

/* ── Regulatory / Insight Cards — glass style ── */
.regulatory-insight-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-xl);
  padding: var(--space-sm);
}

.regulatory-insight-card__body {
  padding: var(--space-sm);
}

.regulatory-insight-card__title {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--color-text-primary);
  margin-bottom: 0.75rem;
  letter-spacing: 0.5px;
}

.regulatory-insight-card__content {
  font-size: var(--font-size-md);
  line-height: 1.5;
  color: var(--color-text-muted);
  margin-bottom: 0.75rem;
}

.regulatory-insight-card__footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.regulatory-insight-card__badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 0.35rem;
  font-size: var(--font-size-sm);
  font-weight: 500;
}

.regulatory-insight-card__date {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  margin-left: auto;
}

.regulatory-insight-card__source {
  font-size: var(--font-size-sm);
  color: rgba(255, 255, 255, 0.4);
  text-decoration: none;
  transition: color 0.15s ease;
}

a.regulatory-insight-card__source:hover {
  color: rgba(255, 255, 255, 0.75);
  text-decoration: underline;
}

/* ============================================
   CHART MODULE LAYOUT
   ============================================ */
.chart-module {
  background: transparent;
  font-family: system-ui, -apple-system, sans-serif;
  padding: 0;
}

.chart-error-banner {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: var(--radius-md);
  padding: 16px;
  margin-bottom: 16px;
  color: #EF4444;
  display: flex;
  align-items: center;
  gap: 12px;
}

.chart-error-banner__title {
  font-weight: 600;
  margin-bottom: 4px;
}

.chart-error-banner__message {
  font-size: 14px;
  opacity: 0.9;
}

.chart-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}

.chart-toolbar__left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  position: relative;
}

.chart-toolbar__center {
  flex: 1 1;
  display: flex;
  justify-content: center;
  width: 100%;
}

.chart-toolbar__right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-toolbar__dropdown {
  position: relative;
}

.chart-timeframe-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}

.chart-area__canvas {
  height: 400px;
  width: 100%;
}

.chart-history-drag-area {
  position: absolute;
  top: 0;
  left: 12px;
  right: 12px;
  height: 100%;
}

.chart-settings-btn--elevated {
  position: relative;
  z-index: 2;
}

.plus-icon-btn__icon {
  position: relative;
  z-index: 1;
  color: #000;
  stroke-width: 2.5;
}

/* ============================================
   MODEL PAGE - Glass overrides for shared components
   ============================================ */

/* Override shared containers (from App.css / chart-main.css) within ModelPage
   to match the transparent glass style of ModelHeader.
   Base .news_comments and .chart-card-container use box-shadow !important for
   border-like glows — we must override with !important to remove them. */
.model_page .news_comments,
.model_page .chart-card-container {
  background: transparent;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  box-shadow: none !important;
}

/* Chart-card-header inside ModelPage — remove its own border/background
   so it doesn't clash with the parent glass container */
.model_page .chart-card-header {
  background: transparent;
  border: none;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.model_page .chart-section{
  margin:1rem 1rem 1rem 0rem;
}


.model_page .table-section{
  margin:1rem 0rem 1rem 1rem;
}
/* Table & Average inner panels — glass sub-containers */
.model_page .table-section,
.model_page .chart-section {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  box-shadow: none !important;
}

/* Main chart area — glass on the chart-area itself */
.model_page .chart-area,
.model_page .chart-area.glass-card-ui {
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  box-shadow: none !important;
  padding: 20px;
}

/* Chart history navigator — glass on the overview element */
.model_page .chart-history-overview {
  background: transparent;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  box-shadow: none !important;
  overflow: visible;
  height: 120px;
}

/* Slider — light white opacity following glass pattern, full height of overview */
.model_page .chart-history-slider {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-2xl);
  box-shadow: none;
  top: 0;
  height: 100%;
}

.model_page .chart-history-slider:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: none;
}

.model_page .chart-history-slider.dragging {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.5);
  box-shadow: none;
}

/* ── Main chart toolbar & buttons — glass borders ── */

/* Toolbar buttons (settings, builder, chart type icons, frequency, alert, export, compare) */
.model_page .chart-btn {
  border: 1px solid var(--border-glass);
}

.model_page .chart-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
}

.model_page .chart-btn.active {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
}

.model_page .chart-btn-styled {
  border: 1px solid var(--border-glass);
}

.model_page .chart-btn-styled:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
}

/* Chart type selector container */
.model_page .chart-type-selector {
  border: 1px solid var(--border-glass);
  border-radius: 40px;
}

/* Timeframe pills (1h, 3h, 1d, etc.) */
.model_page .timeframe-pill {
  border: 1px solid var(--border-glass);
}

.model_page .timeframe-pill:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
  color: #fff;
}

.model_page .timeframe-pill.active {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #fff;
}

/* Date range selector pill */
.model_page .date-selector-pill {
  background: transparent;
  border: 1px solid var(--border-glass);
}

.model_page .date-selector-pill:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
}

.model_page .date-selector-pill.active {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
}

/* Legend buttons */
.model_page .chart-legend-btn {
  border: 1px solid var(--border-glass);
}

.model_page .chart-legend-group {
  border: 1px solid var(--border-glass);
}

/* Compare / search input */
.model_page .compare-dropdown-container .chart-search-container {
  border: 1px solid var(--border-glass);
}

/* Right-side icon buttons (graph icon, plus) */
.model_page .chart-settings-btn {
  background: transparent;
  border: 1px solid var(--border-glass);
}

.model_page .chart-settings-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.5);
}

/* Compare search input — make input fill available space so arrow stays right */
.model_page .compare-dropdown-container .chart-search-input {
  flex: 1 1;
  width: auto;
}

/* Compare dropdown menu */
.model_page .compare-dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 8px;
  background: transparent;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-3xl);
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  z-index: 100;
  overflow: hidden;
}

.model_page .compare-dropdown-list {
  max-height: 250px;
  overflow-y: auto;
  padding: 8px;
  scrollbar-width: none;
}

.model_page .compare-dropdown-list::-webkit-scrollbar {
  width: 0;
}

.model_page .compare-dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 12px;
  transition: background 0.2s ease;
}

.model_page .compare-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.model_page .compare-item-name {
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
}

.model_page .compare-item-price {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.model_page .compare-dropdown-empty {
  padding: 16px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
}

`, "",{"version":3,"sources":["webpack://./src/css/model.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;;iDAEiD;;AAEjD;EACE,UAAU;EACV,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,+CAA+C;EAC/C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,qFAAqF;EACrF,uCAAuC;EACvC,+BAA+B;EAC/B,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,uFAAuF;EACvF,yCAAyC;EACzC,gCAAgC;EAChC,2BAA2B;AAC7B;;;AAGA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,qCAAqC;EACrC,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,uCAAuC;EACvC,uCAAuC;EACvC,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB,EAAE,mBAAmB;EAC5C,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,sCAAsC;EACtC,iCAAiC;EACjC,mCAAmC;EACnC,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,sFAAsF;AACxF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;;iDAEiD;;AAEjD;mEACmE;AACnE;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wCAAwC;EACxC,+BAA+B;EAC/B,uBAAuB;EACvB,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;AACf;;AAEA;;iDAEiD;;AAEjD;+CAC+C;AAC/C;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,8CAA8C;EAC9C,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;EAGE,gCAAgC;EAChC,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,SAAO;EACP,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gCAAgC;EAChC,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,2DAA2D;IAC3D,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA,iDAAiD;EACjD;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;EACE,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA,mDAAmD;AACnD;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;;iDAEiD;AACjD;EACE,uBAAuB;EACvB,iDAAiD;EACjD,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;;iDAEiD;;AAEjD;;;yEAGyE;AACzE;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;wDACwD;AACxD;EACE,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,0BAA0B;AAC5B;AACA,wDAAwD;AACxD;;EAEE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;;EAEE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;AACf;;AAEA,4DAA4D;AAC5D;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;EAChC,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;AACf;;AAEA,kFAAkF;AAClF;EACE,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA,uDAAuD;;AAEvD,6FAA6F;AAC7F;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,kCAAkC;AAClC;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,WAAW;AACb;;AAEA,6BAA6B;AAC7B;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA,gFAAgF;AAChF;EACE,SAAO;EACP,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,gCAAgC;EAChC,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;AACjB","sourcesContent":["/* ============================================\n   MODEL PAGE STYLES\n   ============================================ */\n\n/* Model Page Layout */\n.model_page {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xl);\n  padding: var(--space-xl);\n  min-height: 100vh;\n}\n\n.model_content {\n  display: grid;\n  grid-template-columns: 1fr 400px;\n  gap: var(--space-xl);\n  align-items: start;\n  width: 100%;\n  max-width: 1800px;\n  margin: 0 auto;\n}\n\n.center_column {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xl);\n}\n\n.right_column {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* ============================================\n   MODEL HEADER STYLES\n   ============================================ */\n\n.model-header {\n  padding: 0;\n  background: transparent;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: var(--radius-3xl);\n  border: 1px solid var(--border-glass);\n  border-left: 4px solid var(--color-accent-cyan);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n}\n\n.model-header__container {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: var(--space-xl);\n  align-items: center;\n  padding: 1.25rem var(--space-xl);\n}\n\n.model-header__icon {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(10, 230, 211, 0.05);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-cyan);\n}\n\n.model-header__image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: inherit;\n}\n\n.model-header__content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.model-header__title {\n  font-size: var(--font-size-3xl);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0;\n  line-height: 1.3;\n}\n\n.model-header__description {\n  font-size: var(--font-size-md);\n  color: var(--color-text-muted);\n  line-height: 1.5;\n  margin: 0;\n}\n\n.model-header__price-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.35rem;\n}\n\n.model-header__price {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  line-height: 1;\n}\n\n.model-header__date {\n  font-size: var(--font-size-base);\n  color: var(--color-text-dim);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.model-header__period {\n  color: rgba(255, 255, 255, 0.5);\n  font-size: var(--font-size-sm);\n  font-weight: 400;\n}\n\n.model-header__null {\n  color: rgba(255, 165, 0, 0.7);\n  font-style: italic;\n  font-size: 0.8em;\n}\n\n.model-header__change-row {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  font-size: var(--font-size-md);\n}\n\n.model-header__change-pct {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n}\n\n.model-header__change-icon {\n  margin-right: 4px;\n}\n\n.model-header__change-pct.positive {\n  color: var(--color-positive);\n}\n\n.model-header__change-pct.negative {\n  color: var(--color-negative);\n}\n\n.model-header__change-value {\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n}\n\n.model-header__change-period {\n  color: rgba(255, 255, 255, 0.4);\n  font-size: 0.75rem;\n  font-weight: 400;\n  margin-left: 4px;\n}\n\n.model-header__edit-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-md) 1.25rem;\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.2), rgba(99, 102, 241, 0.2));\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  color: var(--color-primary-muted);\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  margin-left: var(--space-lg);\n}\n\n.model-header__edit-btn:hover {\n  background: linear-gradient(135deg, rgba(139, 92, 246, 0.35), rgba(99, 102, 241, 0.35));\n  border-color: var(--border-primary-hover);\n  color: var(--color-text-primary);\n  transform: translateY(-1px);\n}\n\n\n/* ============================================\n   SUB-PRODUCT TOGGLE PANEL STYLES\n   ============================================ */\n\n.subproduct-toggle-panel {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  padding: var(--space-md) var(--space-lg);\n  background: transparent;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: var(--radius-3xl);\n  border: 1px solid var(--border-glass);\n  margin-bottom: var(--space-lg);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n}\n\n.toggle-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.toggle-panel-title {\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n  color: var(--color-text-dim);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.toggle-panel-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-sm);\n}\n\n.toggle-panel-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: 0.4rem var(--space-md);\n  background: var(--surface-subtle-hover);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.toggle-panel-item.active {\n  background: var(--border-primary-subtle);\n  border-color: var(--border-primary-light);\n}\n\n.toggle-panel-item.inactive {\n  opacity: 0.5;\n}\n\n.toggle-panel-item:hover {\n  border-color: rgba(139, 92, 246, 0.5);\n}\n\n.toggle-color-indicator {\n  width: 10px;\n  height: 10px;\n  border-radius: var(--radius-circle);\n}\n\n.toggle-item-name {\n  font-size: var(--font-size-base);\n  color: var(--color-text-secondary);\n  max-width: 150px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.toggle-icon {\n  color: var(--color-text-dim);\n}\n\n/* ============================================\n   MODEL BREAKDOWN TABLE STYLES\n   ============================================ */\n\n.model-breakdown {\n  padding: 0rem;\n  margin:0.5rem 0rem;\n}\n\n.model-breakdown__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--space-xl);\n}\n\n.model-breakdown__title {\n  font-size: var(--font-size-2xl);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.model-breakdown__table {\n  width: 100%;\n  border-collapse: collapse;\n  background: transparent;\n}\n\n.model-breakdown__table thead tr {\n  background: transparent;\n  border-bottom: none;\n}\n\n.model-breakdown__table th {\n  padding: 0.65rem 0.85rem;\n  text-align: left;\n  font-size: var(--font-size-md);\n  font-weight: 500;\n  color: var(--color-text-dim);\n  font-style: italic;\n  letter-spacing: 0.3px;\n}\n\n.model-breakdown__table tbody tr {\n  border-bottom: none;\n  transition: background-color 0.2s ease;\n}\n\n.model-breakdown__table tbody tr:hover {\n  background-color: var(--surface-subtle);\n}\n\n.model-breakdown__table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.model-breakdown__table td {\n  padding: var(--space-md) 0.85rem;\n  font-size: var(--font-size-md);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.model-breakdown__component-name {\n  font-weight: 400;\n  color: var(--color-text-primary);\n  font-size: var(--font-size-md);\n  line-height: 1.3;\n}\n\n.model-breakdown__component-code {\n  color: var(--color-text-dim);\n  font-size: var(--font-size-sm);\n  font-family: 'Courier New', monospace;\n}\n\n.model-breakdown__section {\n  margin-bottom: var(--space-lg);\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  box-shadow: none;\n}\n\n\n.model-breakdown__section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.75rem 1rem;\n  background: transparent; border-bottom: none;\n  border-radius: 0.5rem 0.5rem 0 0;\n  border-bottom: none;\n}\n\n.model-breakdown__section-title {\n  font-size: var(--font-size-lg);\n  font-weight: 500;\n  color: var(--color-text-secondary);\n}\n\n.model-breakdown__section-actions {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xl);\n}\n\n.model-breakdown__show-chart-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: 0.4rem 0.8rem;\n  background: transparent;\n  border: 1px solid var(--border-medium);\n  border-radius: var(--radius-pill);\n  color: var(--color-text-light-gray);\n  font-weight: 400;\n  font-size: var(--font-size-sm);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.model-breakdown__show-chart-btn:hover {\n  background: rgba(99, 102, 241, 0.1);\n  border-color: rgba(99, 102, 241, 0.6);\n}\n\n.model-breakdown__show-chart-btn svg {\n  width: 10px;\n  height: 10px;\n}\n\n.model-breakdown__show-chart-btn.active {\n  background: rgba(16, 185, 129, 0.15);\n  border-color: rgba(16, 185, 129, 0.5);\n  color: #10B981;\n}\n\n.model-breakdown__show-chart-btn.active svg circle {\n  stroke: #10B981;\n  fill: rgba(16, 185, 129, 0.2);\n}\n\n.model-breakdown__section-header--collapsible {\n  cursor: pointer;\n  user-select: none;\n}\n\n.model-breakdown__section-header--collapsible:hover {\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.model-breakdown__section-title-group {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  color: var(--color-text-secondary);\n}\n\n.model-breakdown__component-name--link {\n  color: var(--color-text-secondary);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\n.model-breakdown__component-name--link:hover {\n  color: var(--color-primary-muted);\n  text-decoration: underline;\n}\n\n.model-breakdown__section-price {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--color-text-primary);\n}\n\n.model-breakdown__section-currency {\n  font-weight: 400;\n  color: #9CA3AF;\n  margin-left: 6px;\n}\n\n.model-breakdown__stability {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.model-breakdown__stability-segment {\n  width: 18px;\n  height: 3px;\n  border-radius: 2px;\n}\n\n.model-breakdown__stability-bar {\n  width: 60px;\n  height: 4px;\n  background: var(--border-default);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.model-breakdown__stability-fill {\n  height: 100%;\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n.model-breakdown__stability-fill--high {\n  background: linear-gradient(90deg, var(--color-positive), var(--color-positive-vivid));\n}\n\n.model-breakdown__stability-fill--medium {\n  background: linear-gradient(90deg, var(--color-warning), var(--color-warning-vivid));\n}\n\n.model-breakdown__stability-fill--low {\n  background: linear-gradient(90deg, var(--color-negative), var(--color-negative-vivid));\n}\n\n.model-breakdown__mini-chart {\n  width: 70px;\n  height: 28px;\n}\n\n.model-breakdown__price {\n  font-weight: 400;\n  color: var(--color-text-primary);\n  font-size: var(--font-size-md);\n  line-height: 1.4;\n}\n\n.model-breakdown__change {\n  font-size: 13px;\n  font-weight: 400;\n  margin-top: 2px;\n}\n\n.model-breakdown__change--positive {\n  color: var(--color-positive);\n}\n\n.model-breakdown__change--negative {\n  color: var(--color-negative);\n}\n\n.model-breakdown__price--market {\n  color: #D1D5DB;\n}\n\n.model-breakdown__mini-chart-empty {\n  width: 100%;\n  height: 100%;\n}\n\n.model-breakdown__source {\n  font-size: var(--font-size-base);\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* ============================================\n   CLASSIFICATION PIE CHART STYLES\n   ============================================ */\n\n/* .classification-chart — root class not used in JSX;\n   the component uses .news_comments as its outer glass container */\n.classification-chart {\n  padding: var(--space-xl);\n}\n\n.classification-chart__header {\n  margin-bottom: var(--space-xl);\n}\n\n.classification-chart__title {\n  font-size: var(--font-size-2xl);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.classification-chart__content {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: var(--space-2xl);\n  align-items: center;\n  padding: var(--space-lg);\n}\n\n.classification-chart__chart-wrapper {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.classification-chart__chart-container {\n  width: 160px;\n  height: 160px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.classification-chart__center-label {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: var(--font-size-2xl);\n  font-weight: 500;\n  color: var(--color-text-primary);\n  text-align: center;\n  pointer-events: none;\n}\n\n.classification-chart__legend {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  width: 100%;\n  justify-content: center;\n}\n\n.classification-chart__legend--grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.25rem 0.5rem;\n  align-content: center;\n}\n\n.classification-chart__legend-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-sm);\n  background: transparent;\n  transition: background-color 0.2s ease;\n  gap: var(--space-md);\n}\n\n.classification-chart__legend-item:hover {\n  background: var(--surface-subtle-hover);\n}\n\n.classification-chart__legend-label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.classification-chart__legend-color {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.classification-chart__legend-name {\n  font-size: var(--font-size-md);\n  color: var(--color-text-secondary);\n}\n\n.classification-chart__legend-value {\n  font-size: var(--font-size-md);\n  font-weight: 500;\n  color: var(--color-text-primary);\n  display: none;\n}\n\n/* ============================================\n   PRICE BREAKDOWN PANEL STYLES\n   ============================================ */\n\n/* .price-breakdown sits on the same element as .news_comments,\n   which already provides the glass container */\n.price-breakdown {\n  padding: 12px 10px;\n}\n\n.price-breakdown__header {\n  margin-bottom: var(--space-md);\n}\n\n.price-breakdown__title {\n  font-size: var(--font-size-xl);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  letter-spacing: 0.3px;\n  text-align: center;\n}\n\n.price-breakdown__list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.price-breakdown__item {\n  display: flex;\n  align-items: baseline;\n  padding: 0.5rem 0.5rem;\n  background: transparent;\n  border: none;\n  transition: background-color 0.2s ease;\n}\n\n.price-breakdown__item.header {\n  border-bottom: 1px solid var(--border-default);\n  padding-bottom: var(--space-sm);\n  margin-bottom: 0;\n}\n\n.price-breakdown__item.header .price-breakdown__item-name,\n.price-breakdown__item.header .price-breakdown__item-percentage,\n.price-breakdown__item.header .price-breakdown__item-price {\n  font-size: var(--font-size-base);\n  color: rgba(255, 255, 255, 0.45);\n  font-style: italic;\n  font-weight: 400;\n}\n\n.price-breakdown__item:not(.header):hover {\n  background: var(--surface-subtle);\n}\n\n.price-breakdown__item-name {\n  font-size: var(--font-size-md);\n  color: var(--color-text-secondary);\n  flex: 1;\n  min-width: 0;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  white-space: normal;\n}\n\n.price-breakdown__item-percentage {\n  font-size: var(--font-size-md);\n  color: var(--color-text-dim);\n  width: 40px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.price-breakdown__item-price {\n  font-size: var(--font-size-md);\n  font-weight: 500;\n  color: var(--color-text-primary);\n  min-width: 110px;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n.price-breakdown__total {\n  margin-top: var(--space-sm);\n  padding-top: var(--space-sm);\n  border-top: 1px solid var(--border-default);\n}\n\n.price-breakdown__total-label {\n  font-size: var(--font-size-lg);\n  font-weight: 600;\n  color: var(--color-text-primary);\n  flex: 1;\n}\n\n.price-breakdown__total-price {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  min-width: 110px;\n  text-align: right;\n  flex-shrink: 0;\n}\n\n/* ============================================\n   RESPONSIVE DESIGN\n   ============================================ */\n\n@media (max-width: 1200px) {\n  .model_content {\n    grid-template-columns: 1fr 350px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .model_content {\n    grid-template-columns: 1fr;\n  }\n\n  .right_column {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n    gap: var(--space-xl);\n  }\n}\n\n@media (max-width: 768px) {\n  .model_page {\n    padding: var(--space-lg);\n  }\n\n  .model_content {\n    gap: var(--space-lg);\n  }\n\n  .center_column,\n  .right_column {\n    gap: var(--space-lg);\n  }\n\n  .model-header {\n    flex-direction: column;\n    gap: var(--space-lg);\n  }\n\n  .model-header__price-info {\n    align-items: flex-start;\n  }\n\n  .model-breakdown__table {\n    font-size: 0.85rem;\n  }\n\n  .model-breakdown__table th,\n  .model-breakdown__table td {\n    padding: 0.5rem;\n  }\n\n  /* Make table horizontally scrollable on mobile */\n  .model-breakdown {\n    overflow-x: auto;\n  }\n\n  .model-breakdown__table {\n    min-width: 800px;\n  }\n}\n\n@media (max-width: 600px) {\n  .model-header__title {\n    font-size: 1.25rem;\n  }\n\n  .model-header__price {\n    font-size: 1.5rem;\n  }\n\n  .right_column {\n    grid-template-columns: 1fr;\n  }\n}\n.model-breakdown__graph-cell {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n/* ── Tabs — glass pill bar within ModelPage ── */\n.model_page .news-tabs {\n  background: transparent;\n  border: 1px solid var(--border-glass);\n  border-radius: 50px;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  padding: 4px;\n}\n\n.model_page .news-tab-btn {\n  color: rgba(255, 255, 255, 0.45);\n  border: 1px solid transparent;\n  transition: color 0.25s, border-color 0.25s, background 0.25s;\n}\n\n.model_page .news-tab-btn.active {\n  background: rgba(255, 255, 255, 0.06);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  box-shadow: none;\n  color: #fff;\n}\n\n.model_page .news-tab-btn:hover:not(.active) {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/* ── Regulatory / Insight Cards — glass style ── */\n.regulatory-insight-card {\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-xl);\n  padding: var(--space-sm);\n}\n\n.regulatory-insight-card__body {\n  padding: var(--space-sm);\n}\n\n.regulatory-insight-card__title {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin-bottom: 0.75rem;\n  letter-spacing: 0.5px;\n}\n\n.regulatory-insight-card__content {\n  font-size: var(--font-size-md);\n  line-height: 1.5;\n  color: var(--color-text-muted);\n  margin-bottom: 0.75rem;\n}\n\n.regulatory-insight-card__footer {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n.regulatory-insight-card__badge {\n  display: inline-block;\n  padding: 0.25rem 0.75rem;\n  border-radius: 0.35rem;\n  font-size: var(--font-size-sm);\n  font-weight: 500;\n}\n\n.regulatory-insight-card__date {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-muted);\n  margin-left: auto;\n}\n\n.regulatory-insight-card__source {\n  font-size: var(--font-size-sm);\n  color: rgba(255, 255, 255, 0.4);\n  text-decoration: none;\n  transition: color 0.15s ease;\n}\n\na.regulatory-insight-card__source:hover {\n  color: rgba(255, 255, 255, 0.75);\n  text-decoration: underline;\n}\n\n/* ============================================\n   CHART MODULE LAYOUT\n   ============================================ */\n.chart-module {\n  background: transparent;\n  font-family: system-ui, -apple-system, sans-serif;\n  padding: 0;\n}\n\n.chart-error-banner {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  margin-bottom: 16px;\n  color: #EF4444;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.chart-error-banner__title {\n  font-weight: 600;\n  margin-bottom: 4px;\n}\n\n.chart-error-banner__message {\n  font-size: 14px;\n  opacity: 0.9;\n}\n\n.chart-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.chart-toolbar__left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  position: relative;\n}\n\n.chart-toolbar__center {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  width: 100%;\n}\n\n.chart-toolbar__right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chart-toolbar__dropdown {\n  position: relative;\n}\n\n.chart-timeframe-bar {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.chart-area__canvas {\n  height: 400px;\n  width: 100%;\n}\n\n.chart-history-drag-area {\n  position: absolute;\n  top: 0;\n  left: 12px;\n  right: 12px;\n  height: 100%;\n}\n\n.chart-settings-btn--elevated {\n  position: relative;\n  z-index: 2;\n}\n\n.plus-icon-btn__icon {\n  position: relative;\n  z-index: 1;\n  color: #000;\n  stroke-width: 2.5;\n}\n\n/* ============================================\n   MODEL PAGE - Glass overrides for shared components\n   ============================================ */\n\n/* Override shared containers (from App.css / chart-main.css) within ModelPage\n   to match the transparent glass style of ModelHeader.\n   Base .news_comments and .chart-card-container use box-shadow !important for\n   border-like glows — we must override with !important to remove them. */\n.model_page .news_comments,\n.model_page .chart-card-container {\n  background: transparent;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  box-shadow: none !important;\n}\n\n/* Chart-card-header inside ModelPage — remove its own border/background\n   so it doesn't clash with the parent glass container */\n.model_page .chart-card-header {\n  background: transparent;\n  border: none;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n.model_page .chart-section{\n  margin:1rem 1rem 1rem 0rem;\n}\n\n\n.model_page .table-section{\n  margin:1rem 0rem 1rem 1rem;\n}\n/* Table & Average inner panels — glass sub-containers */\n.model_page .table-section,\n.model_page .chart-section {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  box-shadow: none !important;\n}\n\n/* Main chart area — glass on the chart-area itself */\n.model_page .chart-area,\n.model_page .chart-area.glass-card-ui {\n  background: rgba(255, 255, 255, 0.02);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  box-shadow: none !important;\n  padding: 20px;\n}\n\n/* Chart history navigator — glass on the overview element */\n.model_page .chart-history-overview {\n  background: transparent;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  box-shadow: none !important;\n  overflow: visible;\n  height: 120px;\n}\n\n/* Slider — light white opacity following glass pattern, full height of overview */\n.model_page .chart-history-slider {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-2xl);\n  box-shadow: none;\n  top: 0;\n  height: 100%;\n}\n\n.model_page .chart-history-slider:hover {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(255, 255, 255, 0.5);\n  box-shadow: none;\n}\n\n.model_page .chart-history-slider.dragging {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.5);\n  box-shadow: none;\n}\n\n/* ── Main chart toolbar & buttons — glass borders ── */\n\n/* Toolbar buttons (settings, builder, chart type icons, frequency, alert, export, compare) */\n.model_page .chart-btn {\n  border: 1px solid var(--border-glass);\n}\n\n.model_page .chart-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.model_page .chart-btn.active {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #fff;\n}\n\n.model_page .chart-btn-styled {\n  border: 1px solid var(--border-glass);\n}\n\n.model_page .chart-btn-styled:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n/* Chart type selector container */\n.model_page .chart-type-selector {\n  border: 1px solid var(--border-glass);\n  border-radius: 40px;\n}\n\n/* Timeframe pills (1h, 3h, 1d, etc.) */\n.model_page .timeframe-pill {\n  border: 1px solid var(--border-glass);\n}\n\n.model_page .timeframe-pill:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n  color: #fff;\n}\n\n.model_page .timeframe-pill.active {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  color: #fff;\n}\n\n/* Date range selector pill */\n.model_page .date-selector-pill {\n  background: transparent;\n  border: 1px solid var(--border-glass);\n}\n\n.model_page .date-selector-pill:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.model_page .date-selector-pill.active {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n}\n\n/* Legend buttons */\n.model_page .chart-legend-btn {\n  border: 1px solid var(--border-glass);\n}\n\n.model_page .chart-legend-group {\n  border: 1px solid var(--border-glass);\n}\n\n/* Compare / search input */\n.model_page .compare-dropdown-container .chart-search-container {\n  border: 1px solid var(--border-glass);\n}\n\n/* Right-side icon buttons (graph icon, plus) */\n.model_page .chart-settings-btn {\n  background: transparent;\n  border: 1px solid var(--border-glass);\n}\n\n.model_page .chart-settings-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n/* Compare search input — make input fill available space so arrow stays right */\n.model_page .compare-dropdown-container .chart-search-input {\n  flex: 1;\n  width: auto;\n}\n\n/* Compare dropdown menu */\n.model_page .compare-dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 8px;\n  background: transparent;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-3xl);\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  z-index: 100;\n  overflow: hidden;\n}\n\n.model_page .compare-dropdown-list {\n  max-height: 250px;\n  overflow-y: auto;\n  padding: 8px;\n  scrollbar-width: none;\n}\n\n.model_page .compare-dropdown-list::-webkit-scrollbar {\n  width: 0;\n}\n\n.model_page .compare-dropdown-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 14px;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 12px;\n  transition: background 0.2s ease;\n}\n\n.model_page .compare-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.model_page .compare-item-name {\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.model_page .compare-item-price {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.model_page .compare-dropdown-empty {\n  padding: 16px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 14px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
